module.exports = __webpack_public_path__ + "img/registration-description-image.f0fbae0f.png";